import { Typography } from "PFComponents/typography";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";
import css from "./privacy_section.module.scss";

type PrivacySectionProps = {
  role: MatchedActivity["activity"];
};

export const PrivacySection = ({ role }: PrivacySectionProps): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleDetails.privacy" });

  return (
    <Section title={t("title")}>
      <Typography variant="bodyRegular" noMargin>
        {role.private ? t("private") : t("public")}
      </Typography>
      <Typography variant="bodyRegular" className={css.privacyDescription} noMargin>
        {role.private ? t("privateDescription") : t("publicDescription")}
      </Typography>
    </Section>
  );
};
